export default "__VITE_ASSET__Cw59xbyv__"